import styled from "styled-components";
import { StyledLandingPageProps } from "./Landing.types";
import { Breakpoints } from "nyc-component-lib";


export const StyledLanding = styled.div`
  height: inherit;
  width: inherit;

  display: grid;
  grid-template-rows: min-content 1fr min-content; //header content footer

  background-color: var(--lib-background);

  #page-content {
    width: inherit;
    padding: var(--lib-default-spacing);
    box-sizing: border-box;
    overflow-y: auto;

    display: grid;
    justify-items: center;
    align-items: center;
  }

  #goto-buttons,
  #image-links {
    width: 4rem;
    height: auto;
    max-width: 25rem;
    display: grid;
    grid-auto-flow: column;
    gap: var(--lib-default-spacing);
    margin-top: 30px;
  }

  #goto-map-btn:hover {
    --calcite-button-background-color: #AE1923;
  }
  #goto-map-btn {
    --calcite-button-background-color: #1A19BC;
  }
    
  #goto-map-btn:focus-visible, #goto-map-btn:focus {
    outline: 2px solid var(--lib-light-blue);
  }

  #map-card,
  #list-card,
  #image-links a div {
    margin: 0px;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: var(--lib-default-spacing);
  }

  #goto-list-card-wrapper {
    display: none;
  }

  #image-links > ul {
    list-style-type: none;
  }

  #image-links .link-card {
    height: 32px; // match the height of goto calcite buttons
  }

  #myloc-btn * {
    padding-inline-end: 0.35rem !important;
  }

  @media screen and (max-width: 40rem) {
    #goto-list-card-wrapper {
      display: inherit;
    }

    #map-card,
    #list-card,
    .link-card {
      aspect-ratio: 5/1.5;
    }
  }

  #bg-title {
    color: #ffffff;
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 0.5em;
  }

  #sml-title {
    color: #ffffff;
    font-size: 1.2em;
    margin-bottom: 0.5em;
  }

  #childbirthday, #searchnearby {
    margin-top: 45px;
    color: #ffffff;
  }

  #page-core {
    width: 466px;
    height: fit-content;
    background-color: #111C76;
    padding 20px;
  }

  calcite-button {
      background-color: #773838;
    }

 @media ${Breakpoints.mobile} {
    #page-core {
      width: auto;
      padding: 5px;
    }
  }

  ${({ backgroundImgSrc }: StyledLandingPageProps) =>
    backgroundImgSrc &&
    `
    #page-content {
       background: linear-gradient(
          rgba(0, 0, 0, var(--app-landing-cover-darkness)),
          rgba(0, 0, 0, var(--app-landing-cover-darkness))
        ),
        url('${backgroundImgSrc}') center;
      background-size: cover;
    `}
`;
